import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { InputComponent } from '../input/input.component';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PermissionsComponent),
    multi: true
};

@Component({
    selector: 'chassis-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss'],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class PermissionsComponent extends InputComponent implements OnInit {

    @Input() formControlName;
    @Input() id: string;
    @Input() field;

    /**
     * Constructor.
     *
     * @param injector
     */
    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * OnInit.
     */
    public ngOnInit() {
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/forms/elements/components/permissions/permissions.component.ts